import { Home } from "../../models/home";
import { Result } from "../../models/result";

export const transformQmiApiResults = (results: Home[]): Result[] => {
	const wrappedResults: Result[] = [];

	results?.forEach((result) => {
		if (result !== undefined) {
			let wrappedResult = {
                //Basic Info
				imageSrc: result.thumbnail,
				url: result.homeUrl,
				uniqueId: result.marketingQmi[0],

				//Address
				address: result.address,
				city: result.address,

				//Location
				position: {
					latitude: result.homeCoordsLat,
					longitude: result.homeCoordsLng,
				},

				//Bedrooms
				bedrooms: [result.bed, result.bed],
				hasBedrooms: result.bed > 0,
				//Bathrooms
				bathrooms: [result.bath, result.bath],
				hasBathrooms: result.bath > 0,
				//Stories
				stories: [result.story, result.story],
				hasStories: result.story > 0,
				//Garages
				garages: [result.garage, result.garage],
				hasGarage: result.garage > 0,
				//Price
				prices: [result.price, result.price],
				//Size
				size: [result.sqrft, result.sqrft],
				hasSize: result.sqrft > 0,
				//Amenities
				amenities: result.amenities,
				//Property Type
				propertyType: result.propertyType,

				homeSeries: result.series,
				
				showCallForInfo: false,
				callForPrice: false,

				availableHomes: 1,

                //QMI-specific data
                lot: result.lot,
                badgeName: result.badgeName,
				monthlyPayment: result.monthlypayment,
				usempc: result.usempc,
                originalprice: result.originalprice,
				mpcconfigid: result.mpcconfigid
			} as Result;

			wrappedResults.push(wrappedResult);
		}
	});

	return wrappedResults;
};
